import { guardarolrequest, rolrequest } from '../roles/domain/request/rol_request';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { pluck, timeout } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { RolResponse } from '../roles/domain/response/rol_response';
import { StorageService } from './storage.service';
import { RolRepository } from '../roles/domain/rol.repository';
import { CobranzasRepository } from '../finanzas/cobranzas/domain/cobranzas_repository';
import { RequestAnularCobranza, RequestImportarCobranzas, RequestListarCobranzas, RequestTransaccionCobranza, RequestdashboardCobranza, envioCorreo_CobranzaRequest } from '../finanzas/cobranzas/domain/request/request_cobranzasdiarias';
import { EnvioCorreoCobranzasResponse, ResponseAnularCobranza, ResponseImportarCobranzasDiarias, ResponseListadoCobranzasDiarias, ResponseListadoReporteEjecutivo, ResponseListadoReporteResumen, ResponseTransaccionCobranzasDiarias, ResponsedashboardCobranza, ResponsedashboardCobranzaEstado, ResponsedashboardCobranzacliente, ResponsedashboardMontoFecha } from '../finanzas/cobranzas/domain/response/response_cobranzasdiarias';
import { proformaRequest } from '../proforma/domain/request/proforma_request';
import { ProformaResponse } from '../proforma/domain/response/proforma_response';
import { enviaCorreoAnulacionesRequest, ListarSolicitudAnulacionRequest, TnsComprobanteRechazoRequest, TransaccionComprobanteAnulRequest } from '../finanzas/solicitud-anulacion/domain/request/solicitud-anulacion-request';
import { ListarSolicitudAnulacionResponse, TransaccionComprobanteAnulResponse } from '../finanzas/solicitud-anulacion/domain/response/solicitud-anulacion-response';
import { ReporteCompAnuladasRequest } from '../finanzas/reportes/domain/request/reportes-finanzas-request';
import { ReporteCompAnuladasDNResponse, ReporteCompAnuladasResponse } from '../finanzas/reportes/domain/response/reportes-finanzas-response';
// import { ResponselistararchivoDescargarComprobante, Responselistarfacturaventa, ValidacionGestionDeAvisosResponse } from '../finanzas/cobranzas/domain/response/response_facturaventa';
// import { request_facturaventa, RequestVisualizarArchivos, ValidacionGestionDeAvisosRequest } from '../finanzas/cobranzas/domain/request/request_facturaventa';
import { GeneralResponse } from '../comercial/reffer/domain/reffer-response';
import { emitirFacturaVentaResponse, getEdicionPreFacturaResponse, getEntidadPorTipoResponse, getFactVtaTicketsResponse, getSerieFacturacionResponse, obtenerArchivosResponse, obtenerFormatoAtendidoResponse, obtenerVouchersResponse, ResponselistararchivoDescargarComprobante, Responselistarfacturaventa, TicketAtendidoResponse, tnsVouchersTicketResponse, ValidacionGestionDeAvisosResponse } from '../finanzas/cobranzas/domain/response/response_facturaventa';
import { atencionPreferencialRequest, atrasoComprobanteRequest, cierreDiarioFactVtaRequest, envioCorreoAtendidoRequest, excepcionPagoRequest, facvtaTicketsRequest, getDetallePreFacturaRequest, getEntidadPorTipoRequest, getSerieFacturacionRequest, issueVoucherRequest, obtenerArchivosRequest, obtenerFormatoAtendidoRequest, request_facturaventa, RequestVisualizarArchivos, tnsVouchersTicketRequest, TransaccionPreFacturaRequest, ValidacionGestionDeAvisosRequest } from '../finanzas/cobranzas/domain/request/request_facturaventa';
import { generalTransaccionResponse } from '../shared/domain/shared.request';
import { generateNewDocumentFacturaRebateRequest, listarRebatePendienteRequest } from '../finanzas/cobranzas/presentacion/rebate-pendiente/domain/rebate-pendiente.request';
import { listarRebatePendienteResponse } from '../finanzas/cobranzas/presentacion/rebate-pendiente/domain/rebate-pendiente.response';

@Injectable()
export class FinanzasService extends CobranzasRepository {

    constructor(private readonly http: HttpClient,
        private readonly storage: StorageService

    ) {

        super();
    }
    listarCobranzasDiarias(request: RequestListarCobranzas): Observable<ResponseListadoCobranzasDiarias> {
        return this.http.post<ResponseListadoCobranzasDiarias>(`${environment.PATH_API}/finanzas/listarcobranzasdiarias/`, request);


    }

    importarCobranzasDiarias(request: RequestImportarCobranzas): Observable<ResponseImportarCobranzasDiarias> {
        return this.http.post<ResponseImportarCobranzasDiarias>(`${environment.PATH_API}/finanzas/importarcobranzas/`, request);


    }


    listardashboardcobranzas(request: RequestdashboardCobranza): Observable<ResponsedashboardCobranza> {
        return this.http.post<ResponsedashboardCobranza>(`${environment.PATH_API}/finanzas/listardashboardcobranzas/`, request);


    }




    listardashboardcobranzascliente(request: RequestdashboardCobranza): Observable<ResponsedashboardCobranzacliente> {
        return this.http.post<ResponsedashboardCobranzacliente>(`${environment.PATH_API}/finanzas/listardashboardcobranzasclientes/`, request);


    }


    listadashboardcobranzasestado(request: RequestdashboardCobranza): Observable<ResponsedashboardCobranzaEstado> {
        return this.http.post<ResponsedashboardCobranzaEstado>(`${environment.PATH_API}/finanzas/listadashboardcobranzasestado/`, request);

    }


    listar(prolrequest: proformaRequest): Observable<ProformaResponse> {
        return this.http.post<ProformaResponse>(`${environment.PATH_API}/parametros/ListaParametros`, prolrequest);
    }

    transaccioncobranzas(request: RequestTransaccionCobranza): Observable<ResponseTransaccionCobranzasDiarias> {
        return this.http.post<ResponseTransaccionCobranzasDiarias>(`${environment.PATH_API}/finanzas/transaccioncobranzas/`, request);
    }

    listadoDashboardMontoPorFecha(request: RequestdashboardCobranza): Observable<ResponsedashboardMontoFecha> {
        return this.http.post<ResponsedashboardMontoFecha>(`${environment.PATH_API}/finanzas/listadashboardcobranzasmontoporfecha/`, request);
    }

    anularCobranza(request: RequestAnularCobranza): Observable<ResponseAnularCobranza> {
        return this.http.post<ResponseAnularCobranza>(`${environment.PATH_API}/finanzas/AnularCobranza/`, request);
    }
    listarReporteEjecutivo(request: RequestListarCobranzas): Observable<ResponseListadoReporteEjecutivo> {
        return this.http.post<ResponseListadoReporteEjecutivo>(`${environment.PATH_API}/finanzas/listarReporteEjecutivo/`, request);
    }
    listarReporteResumen(request: RequestListarCobranzas): Observable<ResponseListadoReporteResumen> {
        return this.http.post<ResponseListadoReporteResumen>(`${environment.PATH_API}/finanzas/listarReporteResumen/`, request);
    }
    listarSolicitudAnulacion(prolrequest: ListarSolicitudAnulacionRequest): Observable<ListarSolicitudAnulacionResponse> {
        return this.http.post<ListarSolicitudAnulacionResponse>(`${environment.PATH_API}/finanzas/ConsultaSolicitudAnulacion/`, prolrequest);
    }
    transaccionComprobanteAnul(prolrequest: TransaccionComprobanteAnulRequest): Observable<TransaccionComprobanteAnulResponse> {
        return this.http.post<TransaccionComprobanteAnulResponse>(`${environment.PATH_API}/finanzas/TransaccionComprobanteAnul/`, prolrequest);
    }
    reporteCompAnuladas(prolrequest: ReporteCompAnuladasRequest): Observable<ReporteCompAnuladasResponse> {
        return this.http.post<ReporteCompAnuladasResponse>(`${environment.PATH_API}/finanzas/ConsultaCompAnuladas/`, prolrequest);
    }
    enviaCorreoAnulaciones(fd: enviaCorreoAnulacionesRequest) {
        return this.http.post(`${environment.PATH_API}/finanzas/EnviarCorreoAnulacion`, fd);
    }
    override reporteCompAnuladasDN(prolrequest: ReporteCompAnuladasRequest): Observable<ReporteCompAnuladasDNResponse> {
        return this.http.post<ReporteCompAnuladasDNResponse>(`${environment.PATH_API}/finanzas/ConsultaCompAnuladas/`, prolrequest);
    }


    override consultafacturaventa(prolrequest: request_facturaventa): Observable<Responselistarfacturaventa> {
        return this.http.post<Responselistarfacturaventa>(`${environment.PATH_API}/finanzas/ConsultaFacturaVentas/`, prolrequest);
    }
    override getTicketsAtencionTicket(prolrequest: facvtaTicketsRequest): Observable<getFactVtaTicketsResponse> {
        return this.http.post<getFactVtaTicketsResponse>(`${environment.PATH_API}/finanzas/getAtencionTicketsCobranza/`, prolrequest);
    }

    override vizualizarcomprobante(prolrequest: RequestVisualizarArchivos): Observable<ResponselistararchivoDescargarComprobante> {
        return this.http.post<ResponselistararchivoDescargarComprobante>(`${environment.PATH_API}/finanzas/visualizararchivocomprobante/`, prolrequest);
    }

    override issueVoucher(request: issueVoucherRequest): Observable<emitirFacturaVentaResponse> {
        return this.http.post<emitirFacturaVentaResponse>(`${environment.PATH_API}/finanzas/issueVouncher/`, request)
    }
    obtenerArchivosFacturaVentas(fd: obtenerArchivosRequest): Observable<obtenerArchivosResponse> {
        return this.http.post<obtenerArchivosResponse>(`${environment.PATH_API}/finanzas/getArchivosFacturaVenta/`, fd);
    }

    override ValidacionGestionDeAvisos(prolrequest: ValidacionGestionDeAvisosRequest): Observable<ValidacionGestionDeAvisosResponse> {
        return this.http.post<ValidacionGestionDeAvisosResponse>(`${environment.PATH_API}/finanzas/ValidacionGestionDeAvisos/`, prolrequest);
    }

    override listarRebatePendiente(request: listarRebatePendienteRequest): Observable<listarRebatePendienteResponse> {
        return this.http.post<listarRebatePendienteResponse>(`${environment.PATH_API}/reffer/ListarRebateInformacion`, request)
    }

    override generateNewDocumentFacturaRebate(request: generateNewDocumentFacturaRebateRequest): Observable<generalTransaccionResponse> {
        return this.http.post<generalTransaccionResponse>(`${environment.PATH_API}/finanzas/GenerateNewDocumentFacturaRebate`, request)
    }

    override obtenerFormatoAtendido(fd: obtenerFormatoAtendidoRequest): Observable<obtenerFormatoAtendidoResponse> {
        return this.http.post<obtenerFormatoAtendidoResponse>(`${environment.PATH_API}/finanzas/obtenerFormatoAtendido`, fd);
    }

    override enviarCorreo(fd: envioCorreo_CobranzaRequest): Observable<EnvioCorreoCobranzasResponse> {
        return this.http.post<EnvioCorreoCobranzasResponse>(`${environment.PATH_API}/generales/enviarCorreoApi`, fd);
    }

    override enviarCorreoAtendido(fd: envioCorreoAtendidoRequest): Observable<TicketAtendidoResponse> {
        return this.http.post<TicketAtendidoResponse>(`${environment.PATH_API}/finanzas/envioCorreoAtendidos`, fd);
    }

    override atencionPreferencial(fd: atencionPreferencialRequest): Observable<generalTransaccionResponse> {
        return this.http.post<generalTransaccionResponse>(`${environment.PATH_API}/finanzas/atencionPreferencial`, fd);
    }

    transaccionComprobanteRechazar(prolrequest: TnsComprobanteRechazoRequest): Observable<generalTransaccionResponse> {
        return this.http.post<generalTransaccionResponse>(`${environment.PATH_API}/finanzas/TransaccionComprobanteRechazo/`, prolrequest);
    }

    registrarAtraso(fd: atrasoComprobanteRequest): Observable<generalTransaccionResponse> {
        return this.http.post<generalTransaccionResponse>(`${environment.PATH_API}/finanzas/atencionAtrasada/`, fd);
    }

    override envioCorreoOperacionPendiente(fd: envioCorreoAtendidoRequest): Observable<generalTransaccionResponse> {
        return this.http.post<generalTransaccionResponse>(`${environment.PATH_API}/finanzas/correoOperacionPendiente`, fd);
    }

    override getListaSerieFacturacion(request: getSerieFacturacionRequest): Observable<getSerieFacturacionResponse> {
        return this.http.post<getSerieFacturacionResponse>(`${environment.PATH_API}/finanzas/ListaSerieFacturacion/`, request)
    }

    override getListaEntidadPorTipo(request: getEntidadPorTipoRequest): Observable<getEntidadPorTipoResponse> {
        return this.http.post<getEntidadPorTipoResponse>(`${environment.PATH_API}/finanzas/ListaEntidadPorTipo/`, request)
    }

    override cierreDiarioFactVta(request: cierreDiarioFactVtaRequest): Observable<generalTransaccionResponse> {
        return this.http.post<generalTransaccionResponse>(`${environment.PATH_API}/finanzas/cierreDiarioFIN/`, request)
    }

    override getEdicionFactVta(request: getDetallePreFacturaRequest): Observable<getEdicionPreFacturaResponse> {
        return this.http.post<getEdicionPreFacturaResponse>(`${environment.PATH_API}/finanzas/getDetallePreFactura/`, request)
    }

    override transaccionPreFactura(request: TransaccionPreFacturaRequest): Observable<generalTransaccionResponse> {
        return this.http.post<generalTransaccionResponse>(`${environment.PATH_API}/finanzas/tnsEdicionPreFactura/`, request)
    }

    override obtenerVouchersFacturaVentas(request: obtenerArchivosRequest): Observable<obtenerVouchersResponse> {
        return this.http.post<obtenerVouchersResponse>(`${environment.PATH_API}/finanzas/getVouchersFacturaVenta/`, request)
    }

    override tnsVouchersTicket(request: tnsVouchersTicketRequest): Observable<tnsVouchersTicketResponse> {
        return this.http.post<tnsVouchersTicketResponse>(`${environment.PATH_API}/finanzas/tnsArchivosTicket/`, request)
    }

}